export default {
  countCells: 10,
  massive: [
    {
      dataField: 'x1',
      cols: 1,
      rows: 1,
      text: 'Образовательные программы',
      class: 'd-flex flex-row align-center justify-start border-right-1',
      headerClass: 'align-start border-bottom-zero border-right-1',
      headerStyles: `min-width: 200px;`,
      order: 0,
      variable: true,
      template: (row) => {
        return row.text
      }
    },
    {
      dataField: 'x2',
      cols: 3,
      rows: 1,
      text: 'Число реализуемых образовательных программ - всего',
      headerClass: 'align-start border-right-1',
      headerStyles: 'padding: 5px',
      order: 2,
      variable: false,
    },
    {
      dataField: 'x3',
      cols: 3,
      rows: 1,
      text: 'Число образовательных программ, реализуемых с использованием сетевой формы, в которых организация выступает в роли базовой организации - всего',
      headerClass: 'align-start border-right-1',
      headerStyles: 'padding: 5px',
      order: 3,
      variable: false,
    },
    {
      dataField: 'x4',
      cols: 3,
      rows: 1,
      text: 'Число обучающихся по образовательным программам, реализуемым с использованием сетевой формы - всего',
      headerClass: 'align-start',
      headerStyles: 'padding: 5px',
      order: 3,
      variable: false,
    },
    {
      dataField: 'x5',
      cols: 1,
      rows: 1,
      text: '',
      class: 'd-flex flex-row align-center justify-start',
      headerClass: 'align-start border-right-1',
      headerStyles: `min-width: 200px;`,
      order: 0,
      variable: false,
    },
    {
      dataField: 'qredb20Vp1',
      cols: 1,
      rows: 1,
      text: `в 2020/21 учебном году`,
      headerStyles: 'padding: 5px',
      headerClass: 'align-start border-right-1',
      class: 'border-right-1 justify-center d-flex',
      order: 5,
      variable: true,
    },
    {
      dataField: 'qredb21Vp1',
      cols: 1,
      rows: 1,
      text: `в 2021/22 учебном году`,
      headerClass: 'align-start border-right-1',
      headerStyles: 'padding: 5px',
      class: 'border-right-1 justify-center d-flex',
      order: 5,
      variable: true,
    },
    {
      dataField: 'qredb22Vp1',
      cols: 1,
      rows: 1,
      text: `в 2022/23 учебном году`,
      headerClass: 'align-start border-right-1',
      headerStyles: 'padding: 5px ',
      class: 'border-right-1 justify-center d-flex',
      order: 5,
      variable: true,
    },
    {
      dataField: 'qesfb20Vp1',
      cols: 1,
      rows: 1,
      text: `в 2020/21 учебном году`,
      headerClass: 'align-start border-right-1',
      headerStyles: 'padding: 5px',
      class: 'border-right-1 justify-center d-flex',
      order: 5,
      variable: true,
    },
    {
      dataField: 'qesfb21Vp1',
      cols: 1,
      rows: 1,
      text: `в 2021/22 учебном году`,
      headerClass: 'align-start border-right-1',
      headerStyles: 'padding: 5px',
      class: 'border-right-1 justify-center d-flex',
      order: 5,
      variable: true,
    },
    {
      dataField: 'qesfb22Vp1',
      cols: 1,
      rows: 1,
      text: `в 2022/23 учебном году`,
      headerClass: 'align-start border-right-1',
      headerStyles: 'padding: 5px',
      class: 'border-right-1 justify-center d-flex',
      order: 5,
      variable: true,
    },
    {
      dataField: 'qpsfb20Vp1',
      cols: 1,
      rows: 1,
      text: `в 2020/21 учебном году`,
      headerClass: 'align-start border-right-1',
      headerStyles: 'padding: 5px',
      class: 'border-right-1 justify-center d-flex',
      order: 5,
      variable: true,
    },
    {
      dataField: 'qpsfb21Vp1',
      cols: 1,
      rows: 1,
      text: `в 2021/22 учебном году`,
      headerStyles: 'padding: 5px',
      headerClass: 'align-start border-right-1',
      class: 'border-right-1 justify-center d-flex',
      order: 5,
      variable: true,
    },
    {
      dataField: 'qpsfb22Vp1',
      cols: 1,
      rows: 1,
      text: `в 2022/23 учебном году`,
      headerClass: 'align-start',
      headerStyles: 'padding: 5px',
      class: 'justify-center d-flex',
      order: 5,
      variable: true,
    },
  ]
}
